/* eslint-disable react/require-default-props */
import React from 'react';
import {
  FieldValues, useController, Path, PathValue,
} from 'react-hook-form';
import AutoComplete, { AutoCompleteProps } from '.';
import { CommonReactHookFormProps } from '../types';

interface RHFAutoCompleteProps<
  T, Value, FormFields extends FieldValues,
> extends AutoCompleteProps<T, Value>, CommonReactHookFormProps<FormFields> {
  onSelectChange?: (data: Value) => void;
}

function RHFAutoComplete<T, Value, FormFields extends FieldValues>(
  props: RHFAutoCompleteProps<T, Value, FormFields>,
) {
  const {
    name,
    control,
    value,
    label,
    options,
    onSelectChange,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>> | undefined,
  });

  const { onChange } = field;

  const handleChange = (event: Value) => {
    onChange(event);
    if (onSelectChange) {
      onSelectChange(event);
    }
  };

  return (
    <AutoComplete
      label={label}
      error={error}
      value={field.value}
      onChange={handleChange}
      options={options}
      {...rest}
    />
  );
}

RHFAutoComplete.defaultProps = {
  onSelectChange: () => { },
};

export default RHFAutoComplete;
